package br.com.heyagenda.di

import br.com.heyagenda.data.local.UserLocalDataSource
import br.com.heyagenda.data.local.UserLocalDataSourceImpl
import br.com.heyagenda.data.remote.FirebaseAuthDataSource
import br.com.heyagenda.data.remote.FirebaseAuthDataSourceImpl
import br.com.heyagenda.data.remote.FirestoreAppointmentDataSource
import br.com.heyagenda.data.remote.FirestoreAppointmentDataSourceImpl
import br.com.heyagenda.data.remote.FirestoreAvailabilityDataSource
import br.com.heyagenda.data.remote.FirestoreAvailabilityDataSourceImpl
import br.com.heyagenda.data.remote.FirestoreClientDataSource
import br.com.heyagenda.data.remote.FirestoreClientDataSourceImpl
import br.com.heyagenda.data.remote.FirestoreProfessionalDataSource
import br.com.heyagenda.data.remote.FirestoreProfessionalDataSourceImpl
import br.com.heyagenda.data.remote.FirestoreServiceDataSource
import br.com.heyagenda.data.remote.FirestoreServiceDataSourceImpl
import br.com.heyagenda.data.repository.AppointmentRepositoryImpl
import br.com.heyagenda.data.repository.AuthRepositoryImpl
import br.com.heyagenda.data.repository.AvailabilityRepositoryImpl
import br.com.heyagenda.data.repository.ClientRepositoryImpl
import br.com.heyagenda.data.repository.ServiceRepositoryImpl
import br.com.heyagenda.domain.repository.AppointmentRepository
import br.com.heyagenda.domain.repository.AuthRepository
import br.com.heyagenda.domain.repository.AvailabilityRepository
import br.com.heyagenda.domain.repository.ClientRepository
import br.com.heyagenda.domain.repository.ServiceRepository
import br.com.heyagenda.domain.usecase.AddAppointmentUseCase
import br.com.heyagenda.domain.usecase.AddDayOffUseCase
import br.com.heyagenda.domain.usecase.DeleteAccountUseCase
import br.com.heyagenda.domain.usecase.DeleteServiceUseCase
import br.com.heyagenda.domain.usecase.DeleteClientUseCase
import br.com.heyagenda.domain.usecase.GetAvailabilityUseCase
import br.com.heyagenda.domain.usecase.GetAvailableTimeSlotsUseCase
import br.com.heyagenda.domain.usecase.GetCurrentUserUseCase
import br.com.heyagenda.domain.usecase.GetAppointmentByIdUseCase
import br.com.heyagenda.domain.usecase.GetAppointmentsForDateUseCase
import br.com.heyagenda.domain.usecase.GetAppointmentsInRangeUseCase
import br.com.heyagenda.domain.usecase.GetAppointmentsPagedUseCase
import br.com.heyagenda.domain.usecase.GetSavedClientsUseCase
import br.com.heyagenda.domain.usecase.GetServicesUseCase
import br.com.heyagenda.domain.usecase.GetTodayAppointmentsUseCase
import br.com.heyagenda.domain.usecase.LoginUseCase
import br.com.heyagenda.domain.usecase.LoginWithAppleUseCase
import br.com.heyagenda.domain.usecase.LoginWithGoogleUseCase
import br.com.heyagenda.domain.usecase.LogoutUseCase
import br.com.heyagenda.domain.usecase.RemoveDateOverrideUseCase
import br.com.heyagenda.domain.usecase.RemoveDayOffUseCase
import br.com.heyagenda.domain.usecase.SaveClientUseCase
import br.com.heyagenda.domain.usecase.SaveDateOverrideUseCase
import br.com.heyagenda.domain.usecase.SaveServiceUseCase
import br.com.heyagenda.domain.usecase.SignUpUseCase
import br.com.heyagenda.domain.usecase.SyncClientsFromAppointmentsUseCase
import br.com.heyagenda.domain.usecase.UpdateAppointmentStatusUseCase
import br.com.heyagenda.domain.usecase.UpdateDayScheduleUseCase
import br.com.heyagenda.presentation.agenda.AgendaScreenModel
import br.com.heyagenda.presentation.appointment.AppointmentDetailScreenModel
import br.com.heyagenda.presentation.availability.WorkingHoursScreenModel
import br.com.heyagenda.presentation.auth.login.LoginScreenModel
import br.com.heyagenda.presentation.auth.signup.SignUpScreenModel
import br.com.heyagenda.presentation.booking.PublicBookingScreenModel
import br.com.heyagenda.presentation.weblink.WebLinkScreenModel
import br.com.heyagenda.presentation.client.ClientManagementScreenModel
import br.com.heyagenda.presentation.dashboard.DashboardScreenModel
import br.com.heyagenda.presentation.service.ServiceManagementScreenModel

object AppModule {

    val authDataSource: FirebaseAuthDataSource by lazy {
        FirebaseAuthDataSourceImpl()
    }

    val firestoreDataSource: FirestoreProfessionalDataSource by lazy {
        FirestoreProfessionalDataSourceImpl()
    }

    val firestoreProfessionalDataSource: FirestoreProfessionalDataSource
        get() = firestoreDataSource

    val firestoreAppointmentDataSource: FirestoreAppointmentDataSource by lazy {
        FirestoreAppointmentDataSourceImpl()
    }

    val firestoreServiceDataSource: FirestoreServiceDataSource by lazy {
        FirestoreServiceDataSourceImpl()
    }

    val firestoreAvailabilityDataSource: FirestoreAvailabilityDataSource by lazy {
        FirestoreAvailabilityDataSourceImpl()
    }

    val userLocalDataSource: UserLocalDataSource by lazy {
        UserLocalDataSourceImpl()
    }

    val authRepository: AuthRepository by lazy {
        AuthRepositoryImpl(
            authDataSource = authDataSource,
            firestoreDataSource = firestoreDataSource,
            localDataSource = userLocalDataSource
        )
    }

    val firestoreClientDataSource: FirestoreClientDataSource by lazy {
        FirestoreClientDataSourceImpl()
    }

    val clientRepository: ClientRepository by lazy {
        ClientRepositoryImpl(
            clientDataSource = firestoreClientDataSource,
            authDataSource = authDataSource,
            appointmentDataSource = firestoreAppointmentDataSource
        )
    }

    val appointmentRepository: AppointmentRepository by lazy {
        AppointmentRepositoryImpl(
            firestoreDataSource = firestoreAppointmentDataSource,
            authDataSource = authDataSource,
            clientDataSource = firestoreClientDataSource
        )
    }

    val serviceRepository: ServiceRepository by lazy {
        ServiceRepositoryImpl(
            firestoreDataSource = firestoreServiceDataSource,
            authDataSource = authDataSource
        )
    }

    val availabilityRepository: AvailabilityRepository by lazy {
        AvailabilityRepositoryImpl(
            firestoreDataSource = firestoreAvailabilityDataSource,
            authDataSource = authDataSource
        )
    }

    val firestoreExpenseDataSource: br.com.heyagenda.data.remote.FirestoreExpenseDataSource by lazy {
        br.com.heyagenda.data.remote.FirestoreExpenseDataSourceImpl()
    }

    val expenseRepository: br.com.heyagenda.domain.repository.ExpenseRepository by lazy {
        br.com.heyagenda.data.repository.ExpenseRepositoryImpl(
            firestoreDataSource = firestoreExpenseDataSource,
            authDataSource = authDataSource
        )
    }

    val whatsAppRepository: br.com.heyagenda.data.repository.WhatsAppRepository by lazy {
        br.com.heyagenda.data.repository.WhatsAppRepositoryImpl(
            authRepository = authRepository
        )
    }

    val loginUseCase: LoginUseCase by lazy {
        LoginUseCase(authRepository = authRepository)
    }

    val signUpUseCase: SignUpUseCase by lazy {
        SignUpUseCase(authRepository = authRepository)
    }

    val getCurrentUserUseCase: GetCurrentUserUseCase by lazy {
        GetCurrentUserUseCase(authRepository = authRepository)
    }

    val logoutUseCase: LogoutUseCase by lazy {
        LogoutUseCase(authRepository = authRepository)
    }

    val deleteAccountUseCase: DeleteAccountUseCase by lazy {
        DeleteAccountUseCase(authRepository = authRepository)
    }

    val getTodayAppointmentsUseCase: GetTodayAppointmentsUseCase by lazy {
        GetTodayAppointmentsUseCase(repository = appointmentRepository)
    }

    val getAppointmentsForDateUseCase: GetAppointmentsForDateUseCase by lazy {
        GetAppointmentsForDateUseCase(repository = appointmentRepository)
    }

    val getAppointmentByIdUseCase: GetAppointmentByIdUseCase by lazy {
        GetAppointmentByIdUseCase(repository = appointmentRepository)
    }

    val getAppointmentsInRangeUseCase: GetAppointmentsInRangeUseCase by lazy {
        GetAppointmentsInRangeUseCase(repository = appointmentRepository)
    }

    val getAppointmentsPagedUseCase: GetAppointmentsPagedUseCase by lazy {
        GetAppointmentsPagedUseCase(repository = appointmentRepository)
    }

    val getSavedClientsUseCase: GetSavedClientsUseCase by lazy {
        GetSavedClientsUseCase(repository = clientRepository)
    }

    val saveClientUseCase: SaveClientUseCase by lazy {
        SaveClientUseCase(repository = clientRepository)
    }

    val deleteClientUseCase: DeleteClientUseCase by lazy {
        DeleteClientUseCase(repository = clientRepository)
    }

    val syncClientsFromAppointmentsUseCase: SyncClientsFromAppointmentsUseCase by lazy {
        SyncClientsFromAppointmentsUseCase(repository = clientRepository)
    }

    val updateAppointmentStatusUseCase: UpdateAppointmentStatusUseCase by lazy {
        UpdateAppointmentStatusUseCase(repository = appointmentRepository)
    }

    val addAppointmentUseCase: AddAppointmentUseCase by lazy {
        AddAppointmentUseCase(repository = appointmentRepository)
    }

    val getServicesUseCase: GetServicesUseCase by lazy {
        GetServicesUseCase(repository = serviceRepository)
    }

    val saveServiceUseCase: SaveServiceUseCase by lazy {
        SaveServiceUseCase(repository = serviceRepository)
    }

    val deleteServiceUseCase: DeleteServiceUseCase by lazy {
        DeleteServiceUseCase(repository = serviceRepository)
    }

    val getAvailabilityUseCase: GetAvailabilityUseCase by lazy {
        GetAvailabilityUseCase(repository = availabilityRepository)
    }

    val updateDayScheduleUseCase: UpdateDayScheduleUseCase by lazy {
        UpdateDayScheduleUseCase(repository = availabilityRepository)
    }

    val addDayOffUseCase: AddDayOffUseCase by lazy {
        AddDayOffUseCase(repository = availabilityRepository)
    }

    val removeDayOffUseCase: RemoveDayOffUseCase by lazy {
        RemoveDayOffUseCase(repository = availabilityRepository)
    }

    val saveDateOverrideUseCase: SaveDateOverrideUseCase by lazy {
        SaveDateOverrideUseCase(repository = availabilityRepository)
    }

    val removeDateOverrideUseCase: RemoveDateOverrideUseCase by lazy {
        RemoveDateOverrideUseCase(repository = availabilityRepository)
    }

    val getAvailableTimeSlotsUseCase: GetAvailableTimeSlotsUseCase by lazy {
        GetAvailableTimeSlotsUseCase(repository = availabilityRepository)
    }

    val updateSlugUseCase: br.com.heyagenda.domain.usecase.UpdateSlugUseCase by lazy {
        br.com.heyagenda.domain.usecase.UpdateSlugUseCase(authRepository = authRepository)
    }

    val getProfessionalBySlugUseCase: br.com.heyagenda.domain.usecase.GetProfessionalBySlugUseCase by lazy {
        br.com.heyagenda.domain.usecase.GetProfessionalBySlugUseCase(professionalDataSource = firestoreDataSource)
    }

    val loginWithGoogleUseCase: LoginWithGoogleUseCase by lazy {
        LoginWithGoogleUseCase(authRepository = authRepository)
    }

    val loginWithAppleUseCase: LoginWithAppleUseCase by lazy {
        LoginWithAppleUseCase(authRepository = authRepository)
    }

    val completeSocialSignUpUseCase: br.com.heyagenda.domain.usecase.CompleteSocialSignUpUseCase by lazy {
        br.com.heyagenda.domain.usecase.CompleteSocialSignUpUseCase(authRepository = authRepository)
    }

    fun provideLoginScreenModel(): LoginScreenModel {
        return LoginScreenModel(
            loginUseCase = loginUseCase,
            loginWithGoogleUseCase = loginWithGoogleUseCase,
            loginWithAppleUseCase = loginWithAppleUseCase,
            authRepository = authRepository
        )
    }

    fun provideSignUpScreenModel(): SignUpScreenModel {
        return SignUpScreenModel(
            signUpUseCase = signUpUseCase,
            loginWithGoogleUseCase = loginWithGoogleUseCase,
            loginWithAppleUseCase = loginWithAppleUseCase,
            completeSocialSignUpUseCase = completeSocialSignUpUseCase,
            authRepository = authRepository,
            logoutUseCase = logoutUseCase
        )
    }

    fun provideDashboardScreenModel(): DashboardScreenModel {
        return DashboardScreenModel(
            getCurrentUserUseCase = getCurrentUserUseCase,
            getTodayAppointmentsUseCase = getTodayAppointmentsUseCase,
            getAppointmentsInRangeUseCase = getAppointmentsInRangeUseCase,
            updateAppointmentStatusUseCase = updateAppointmentStatusUseCase,
            addAppointmentUseCase = addAppointmentUseCase,
            expenseRepository = expenseRepository,
            logoutUseCase = logoutUseCase,
            updateSlugUseCase = updateSlugUseCase,
            syncClientsFromAppointmentsUseCase = syncClientsFromAppointmentsUseCase
        )
    }

    fun providePublicBookingScreenModel(slugOrUid: String = ""): PublicBookingScreenModel {
        return PublicBookingScreenModel(
            slugOrUid = slugOrUid,
            getProfessionalBySlugUseCase = getProfessionalBySlugUseCase,
            firestoreServiceDataSource = firestoreServiceDataSource,
            firestoreAvailabilityDataSource = firestoreAvailabilityDataSource,
            firestoreAppointmentDataSource = firestoreAppointmentDataSource,
            firestoreClientDataSource = firestoreClientDataSource
        )
    }

    fun provideServiceManagementScreenModel(): ServiceManagementScreenModel {
        return ServiceManagementScreenModel(
            getServicesUseCase = getServicesUseCase,
            saveServiceUseCase = saveServiceUseCase,
            deleteServiceUseCase = deleteServiceUseCase
        )
    }

    fun provideWorkingHoursScreenModel(): WorkingHoursScreenModel {
        return WorkingHoursScreenModel(
            getAvailabilityUseCase = getAvailabilityUseCase,
            updateDayScheduleUseCase = updateDayScheduleUseCase,
            addDayOffUseCase = addDayOffUseCase,
            removeDayOffUseCase = removeDayOffUseCase,
            saveDateOverrideUseCase = saveDateOverrideUseCase,
            removeDateOverrideUseCase = removeDateOverrideUseCase
        )
    }

    fun provideAgendaScreenModel(): AgendaScreenModel {
        return AgendaScreenModel(
            getAppointmentsInRangeUseCase = getAppointmentsInRangeUseCase,
            getAppointmentsPagedUseCase = getAppointmentsPagedUseCase,
            updateAppointmentStatusUseCase = updateAppointmentStatusUseCase,
            addAppointmentUseCase = addAppointmentUseCase,
            syncClientsFromAppointmentsUseCase = syncClientsFromAppointmentsUseCase
        )
    }

    fun provideAppointmentDetailScreenModel(appointmentId: String): AppointmentDetailScreenModel {
        return AppointmentDetailScreenModel(
            appointmentId = appointmentId,
            getAppointmentByIdUseCase = getAppointmentByIdUseCase,
            updateAppointmentStatusUseCase = updateAppointmentStatusUseCase,
            getCurrentUserUseCase = getCurrentUserUseCase
        )
    }

    fun provideNewAppointmentScreenModel(
        initialDateIso: String? = null,
        initialClient: br.com.heyagenda.domain.model.SavedClient? = null
    ): br.com.heyagenda.presentation.appointment.NewAppointmentScreenModel {
        return br.com.heyagenda.presentation.appointment.NewAppointmentScreenModel(
            initialDateIso = initialDateIso,
            initialClient = initialClient,
            addAppointmentUseCase = addAppointmentUseCase,
            getServicesUseCase = getServicesUseCase,
            getAvailabilityUseCase = getAvailabilityUseCase,
            getAppointmentsForDateUseCase = getAppointmentsForDateUseCase,
            getSavedClientsUseCase = getSavedClientsUseCase
        )
    }

    fun provideWebLinkScreenModel(): WebLinkScreenModel {
        return WebLinkScreenModel(
            getCurrentUserUseCase = getCurrentUserUseCase,
            authRepository = authRepository,
            updateSlugUseCase = updateSlugUseCase,
            appointmentRepository = appointmentRepository
        )
    }

    fun provideProfileScreenModel(): br.com.heyagenda.presentation.profile.ProfileScreenModel {
        return br.com.heyagenda.presentation.profile.ProfileScreenModel(
            authRepository = authRepository,
            logoutUseCase = logoutUseCase,
            deleteAccountUseCase = deleteAccountUseCase
        )
    }

    fun provideWhatsAppSettingsScreenModel(): br.com.heyagenda.presentation.whatsapp.WhatsAppSettingsScreenModel {
        return br.com.heyagenda.presentation.whatsapp.WhatsAppSettingsScreenModel(
            whatsAppRepository = whatsAppRepository,
            authRepository = authRepository
        )
    }

    fun provideFinancialScreenModel(): br.com.heyagenda.presentation.financial.FinancialScreenModel {
        return br.com.heyagenda.presentation.financial.FinancialScreenModel(
            getAppointmentsInRangeUseCase = getAppointmentsInRangeUseCase,
            getCurrentUserUseCase = getCurrentUserUseCase,
            expenseRepository = expenseRepository
        )
    }

    fun provideClientManagementScreenModel(): ClientManagementScreenModel {
        return ClientManagementScreenModel(
            getSavedClientsUseCase = getSavedClientsUseCase,
            saveClientUseCase = saveClientUseCase,
            deleteClientUseCase = deleteClientUseCase,
            syncClientsFromAppointmentsUseCase = syncClientsFromAppointmentsUseCase
        )
    }

    val billingService: br.com.heyagenda.domain.billing.BillingService by lazy {
        br.com.heyagenda.domain.billing.DefaultBillingService(authRepository, appointmentRepository)
    }

    fun provideSubscriptionScreenModel(): br.com.heyagenda.presentation.subscription.SubscriptionScreenModel {
        return br.com.heyagenda.presentation.subscription.SubscriptionScreenModel(
            billingService = billingService,
            getCurrentUserUseCase = getCurrentUserUseCase
        )
    }
}
